module.exports = __webpack_public_path__ + "img/dragonflyai.7ff5cbd0.png";